import React from 'react';

import {emotionStyled} from '@packages/utilities/styled';
import {Spinner, Text} from '@packages/systems/spring';

const Overlay = emotionStyled('div')(
  {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: '$background2',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '$4',
    height: '100%',
  },
  {
    variants: {
      position: {
        absolute: {
          position: 'absolute',
        },
        fixed: {
          position: 'fixed',
        },
      },
    },
    defaultVariants: {
      position: 'absolute',
    },
  }
);

type LoaderOverlayProps = {
  position?: 'absolute' | 'fixed';
  text?: string;
};

const LoaderOverlay = ({position, text}: LoaderOverlayProps) => (
  <Overlay data-automation-id="loading-overlay" position={position}>
    <Spinner />
    {text && (
      <Text font="title" data-automation-id="loading-overlay-text">
        {text}
      </Text>
    )}
  </Overlay>
);

export default LoaderOverlay;
